import { VocabularyInfo } from '@/types/vocabulary-management/VocabularyBundle';
import { Table } from '@prometheus/components';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface VocabularyListProps {
  data: Array<VocabularyInfo>;
}
export const VocabularyList: FC<VocabularyListProps> = ({ data }) => {
  const { t } = useTranslation();
  return (
    <Table
      columns={[
        {
          Header: t('tables.cols.id'),
          accessor: 'externalId',
          id: 'externalId',
        },
        { Header: t('tables.cols.code'), accessor: 'code', id: 'code' },
        { Header: t('tables.cols.name'), accessor: 'name', id: 'name' },
      ]}
      data={data}
      totalElements={data?.length}
      pageSize={data?.length}
      enableSorting
    />
  );
};
